/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 设置文件权限
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  fileACLDto: oss.FileACLDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oss.FileACLDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "patch",
    url: `/oss/fileACL`,
    data: fileACLDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
